import DatePicker from '../core/DatePicker';

import type { RangeDatePickerChangeHandler, RangeDatePickerProps } from '../types';

/**
 * Range 선택에 특화된 DatePicker wrapper 컴포넌트의 Props입니다.
 *
 * @example
 * ```tsx
 * <DateRangePicker
 *   startDate={startDate}
 *   endDate={endDate}
 *   onChange={([start, end]) => {
 *     setStartDate(start);
 *     setEndDate(end);
 *   }}
 * />
 * ```
 */
export interface DateRangePickerProps extends Omit<RangeDatePickerProps, 'selectsRange'> {
  /**
   * range picker에서 끝 날짜를 지정합니다.
   */
  endDate?: Date | null;

  /**
   * 날짜 범위 변경 시 호출되는 함수입니다.
   * 배열 형태로 [startDate, endDate]를 받습니다.
   */
  onChange?: RangeDatePickerChangeHandler;

  /**
   * range picker에서 시작 날짜를 지정합니다.
   */
  startDate?: Date | null;
}

/**
 * DatePicker를 wrapping하여 Range 선택 전용으로 사용하는 컴포넌트입니다.
 * 내부적으로 selectsRange를 true로 고정하여 DatePicker에 전달합니다.
 */
const DateRangePicker = (props: DateRangePickerProps) => {
  return <DatePicker {...props} selectsRange />;
};

DateRangePicker.displayName = 'DateRangePicker';

export default DateRangePicker;
